const CSV_PREFIX = "text/csv"
const IMAGE_PREFIX = "image/"
const JSON_PREFIX = "application/json"
const MARKDOWN_APPLICATION_PREFIX = "application/markdown"
const MICROSOFT_PREFIXE = "application/vnd.ms-access"
const MS_WORD_PREFIX = "application/msword"
const OFFICE_PREFIX = "application/vnd.openxmlformats-officedocument"
const PDF_PREFIX = "application/pdf"
const PLAIN_TEXT_PREFIX = "text/plain"
const TEXT_MARKDOWN_PREFIX = "text/markdown"
const TEXT_X_MARKDOWN_PREFIX = "text/x-markdown"
const VIDEO_PREFIX = "video/"
const XML_TEXT_PREFIX = "text/xml"

export const isCsv = (type: string) => type === CSV_PREFIX || CSV_PREFIX.includes(type)
export const isImage = (type: string) => type.startsWith(IMAGE_PREFIX) || IMAGE_PREFIX.includes(type)
export const isJson = (type: string) => type === JSON_PREFIX || JSON_PREFIX.includes(type)
export const isMarkdown = (type: string) => type === MARKDOWN_APPLICATION_PREFIX || MARKDOWN_APPLICATION_PREFIX.includes(type)
export const isMsFile = (type: string) => type === MS_WORD_PREFIX || type.startsWith(MICROSOFT_PREFIXE) || MICROSOFT_PREFIXE.includes(type)
export const isOfficeFile = (type: string) => type.startsWith(OFFICE_PREFIX)
export const isPdf = (type: string) => type === PDF_PREFIX || PDF_PREFIX.includes(type)
export const isPlainText = (type: string) => type === PLAIN_TEXT_PREFIX || type === XML_TEXT_PREFIX
export const isTextMarkdown = (type: string) => type === TEXT_MARKDOWN_PREFIX || TEXT_MARKDOWN_PREFIX.includes(type) || TEXT_X_MARKDOWN_PREFIX.includes(type)
export const isVideo = (type: string) => type.startsWith(VIDEO_PREFIX) || VIDEO_PREFIX.includes(type)